// Client diagnostics must not include Axios configs, native payloads or messages.
const CODES = new Set(["ERR_NETWORK", "ECONNABORTED", "ETIMEDOUT", "UNAVAILABLE", "PERMISSION_DENIED"]);
export function safeErrorDetails(error) {
  try {
    const details = { category: error?.name === "AxiosError" ? "network" : "application" };
    if (CODES.has(error?.code)) details.code = error.code;
    return details;
  } catch {
    return { category: "application" };
  }
}
